import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';

export type AuditAction = 'confirm' | 'edit' | 'reject_fact' | 'reject_relevance' | 'uncertain' | 'snooze';

interface AuditPayload {
  itemId: string;
  action: AuditAction;
  reason?: string;
  newValue?: Record<string, unknown>;
}

interface AuditResponse {
  ok: boolean;
  itemId: string;
  action: string;
  newStatus: string;
}

export function useAuditAction() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: AuditPayload) =>
      apiFetch<AuditResponse>('/api/surfaces/team/audit', {
        method: 'POST',
        body: JSON.stringify(payload),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['surfaces', 'team-today'] });
    },
  });
}
